import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody25';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy25 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'> Tourism Industry Research</h2><h4>For a company operating in the hospitality sector</h4>";

  return (
    <>
        <Helmet>
        <title>Tourism Industry Research For a company operating in the hospitality sector</title>
        <meta property="og:title" content="Tourism Industry Research For a company operating in the hospitality sector" />
        <meta property='og:description' content='Tourism Industry Research For a company operating in the hospitality sector'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy20" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy25
